import * as React from 'react';
const AerofagiaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M85.69 56c-3.05 3.79-3.86 11.01-2.19 15.59 1.66 4.58 4.72 8.49 7.45 12.52s5.23 8.48 5.53 13.35c.44 7.16-4.63 14.29-11.5 16.17-6.73 1.84-14.5-.86-20.55 2.63-4.57 2.64-6.79 8.27-6.8 13.58-.02 5.31 1.34 9.16 3.13 14.16M141.07 100.51c2.61-10.44 1.78-21.35-6.94-28.51-3.85-3.16-8.94-5.09-13.86-5.5-3.9-.32-7.58.75-11.02 2.55-2.97 1.56-5.57 4.25-9.19 3.66-3.13-.51-5.66-3.71-6.46-6.69-.83-3.09.77-7.57 2.79-10.03"
      className="prefix__cls-2"
    />
    <path
      d="M73.23 144c-1.16-2.07-2.55-4.49-3.19-6.78-.83-2.99-.8-6.93 1.9-8.97 1.59-1.21 3.83-1.49 5.67-.71 1.61.68 2.83 2.05 3.98 3.37 2.76 3.17 5.86 5.95 9.76 7.62 4.83 2.07 10.24 2.31 15.4 1.19"
      className="prefix__cls-2"
    />
    <circle cx={117.08} cy={126.24} r={8.76} className="prefix__cls-1" />
    <path
      d="M124.61 130.71c1.26 1 2.86 1.6 4.6 1.6 4.1 0 7.42-3.32 7.42-7.42s-3.32-7.42-7.42-7.42c-2.33 0-4.41 1.07-5.76 2.75"
      className="prefix__cls-1"
    />
    <circle cx={135.28} cy={110.06} r={4.72} className="prefix__cls-1" />
    <circle cx={107.64} cy={109.38} r={3.37} className="prefix__cls-1" />
    <circle cx={131.91} cy={138.37} r={3.37} className="prefix__cls-1" />
  </svg>
);
export default AerofagiaIcon;
